{
 "_meta": {
  "locale": "es",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Ahora",
  "people": "Personas",
  "cases": "Casos",
  "agenda": "Agenda",
  "reviews": "Revisiones",
  "prospects": "Prospección",
  "insights": "Análisis",
  "data": "Datos y seguridad",
  "settings": "Ajustes",
  "lens": "Lupa"
 },
 "common": {
  "save": "Guardar",
  "cancel": "Cancelar",
  "close": "Cerrar",
  "search": "Buscar",
  "today": "Hoy",
  "tomorrow": "Mañana",
  "new": "Nuevo",
  "edit": "Editar",
  "delete": "Eliminar"
 },
 "settings": {
  "title": "Ajustes",
  "language": "Idioma",
  "region": "Mercado / región",
  "theme": "Apariencia"
 },
 "people": {
  "title": "Personas",
  "new": "Nueva persona"
 },
 "today": {
  "agenda_title": "Hoy"
 },
 "lens": {
  "placeholder": "Buscar personas, prospectos, casos — o escribir un comando"
 }
}